const collectionFilterSidebarStates = new Map();

class CollectionFilterToolbar extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-desktop-filter-toggle]');
    this.collectionWrapper = this.closest('.collection-wrapper');
    this.sidebar = this.getSidebar();

    if (!this.button || !this.sidebar) return;

    this.restoreSidebarState();
    this.button.addEventListener('click', () => this.toggleSidebar());
    this.sidebarObserver = new MutationObserver(() => this.handleSectionUpdate());
    this.sidebarObserver.observe(this.collectionWrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    this.updateButton();
  }

  disconnectedCallback() {
    this.sidebarObserver?.disconnect();
  }

  getSidebar() {
    return this.collectionWrapper?.querySelector('.facets-block-wrapper--vertical:not(#filters-drawer)');
  }

  get storageKey() {
    return window.location.pathname;
  }

  restoreSidebarState() {
    const isOpen = collectionFilterSidebarStates.has(this.storageKey)
      ? collectionFilterSidebarStates.get(this.storageKey)
      : this.dataset.defaultOpen === 'true';

    this.sidebar.classList.toggle('hidden', !isOpen);
  }

  handleSectionUpdate() {
    const updatedSidebar = this.getSidebar();
    if (!updatedSidebar) return;

    this.sidebar = updatedSidebar;

    const isOpen = collectionFilterSidebarStates.get(this.storageKey) ?? this.dataset.defaultOpen === 'true';
    this.sidebar.classList.toggle('hidden', !isOpen);

    this.updateButton();
  }

  toggleSidebar() {
    this.sidebar.classList.toggle('hidden');
    collectionFilterSidebarStates.set(this.storageKey, !this.sidebar.classList.contains('hidden'));
    this.updateButton();
  }

  updateButton() {
    const isOpen = !this.sidebar.classList.contains('hidden');
    this.classList.toggle('show-filter', isOpen);
    this.button.setAttribute('aria-expanded', String(isOpen));
    const label = this.button.querySelector('[data-filter-toggle-label]');
    const nextLabel = isOpen ? this.button.dataset.closeLabel : this.button.dataset.showLabel;
    if (label.textContent !== nextLabel) label.textContent = nextLabel;
  }
}

if (!customElements.get('collection-filter-toolbar')) {
  customElements.define('collection-filter-toolbar', CollectionFilterToolbar);
}

// Preserve query parameters (such as sort_by) when navigating between category/brand links
document.addEventListener('click', (event) => {
  const link = event.target.closest('.shop-by-category__link, .shop-by-brand__link');
  if (!link || !window.location.search) return;

  try {
    const targetUrl = new URL(link.href, window.location.origin);
    if (!targetUrl.search) {
      targetUrl.search = window.location.search;
      link.href = targetUrl.toString();
    }
  } catch (e) {
    // Ignore invalid URLs
  }
});
